"use client"

import { AnimatedSection } from "./AnimatedSection"
import { chennaiAgenda } from "./chennaiAgenda"

// All Chennai session recordings in one place. Rows without a videoId (recording
// not published yet) are skipped.
export function SessionVideosSection() {
  const videos = chennaiAgenda
    .filter((row) => row.topic.videoId)
    .map((row) => ({
      id: row.topic.id,
      videoId: row.topic.videoId,
      title: row.topic.title,
      category: row.topic.category,
      speakers: row.speakers.map((s) => s.name).join(" & "),
    }))

  if (videos.length === 0) return null

  return (
    <section className="py-16 bg-gradient-to-br from-green-50 via-white to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-green-800 mb-4">Session Recordings</h2>
            <p className="text-xl text-green-600 max-w-2xl mx-auto">
              Every talk from the Chennai Edition, in agenda order.
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {videos.map((video, index) => (
            <AnimatedSection key={video.id} delay={index * 100}>
              <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-green-100 h-full flex flex-col">
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.videoId}`}
                    title={video.title}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                  ></iframe>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <span className="inline-block self-start text-xs font-semibold text-green-700 bg-green-100 rounded-full px-3 py-1 mb-3">
                    {video.category}
                  </span>
                  <h3 className="text-lg font-bold text-green-800 mb-2 leading-snug">{video.title}</h3>
                  <p className="text-sm text-green-600 mt-auto">{video.speakers}</p>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  )
}
